export enum ServiceLevelAgreementsEventName {
  UserEntersServiceLevelAgreementsDashboard = 'userEntersServiceLevelAgreementsDashboard'
}

export type ServiceLevelAgreementsEvent = {
  name: ServiceLevelAgreementsEventName.UserEntersServiceLevelAgreementsDashboard
  data: {}
}
